import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "../data/mock";

const Testimonials = () => {
  return (
    <section id="testimonials" className="section relative overflow-hidden" style={{ background: "#0a0908" }}>
      {/* Ambient background glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full opacity-10 blur-[120px]"
        style={{ background: "var(--gold)" }} />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-5 blur-[100px]"
        style={{ background: "var(--gold)" }} />

      <div className="container-xl relative z-10">
        <Kicker index="09" label="Voices of our clients" />
        
        <div className="mt-16 grid md:grid-cols-2 gap-8 lg:gap-12">
          {testimonials.slice(0, 2).map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.2 }}
              className="group relative aspect-[4/3] md:aspect-[16/10] rounded-sm overflow-hidden border border-[rgba(201,169,97,0.15)]"
            >
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-110"
                style={{ backgroundImage: `url(${t.bgImage})`, filter: "grayscale(0.3) brightness(0.4) contrast(1.1)" }}
              />
              
              {/* Overlays */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0908] via-[rgba(10,9,8,0.4)] to-transparent" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{ background: "radial-gradient(circle at center, rgba(228,199,122,0.05) 0%, transparent 70%)" }} />

              <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-between">
                <Quote size={40} className="text-[var(--gold)] opacity-40" strokeWidth={1} />
                
                <div>
                  <blockquote className="font-display italic text-[clamp(20px,2.2vw,32px)] leading-[1.3] text-[var(--cream)] mb-8">
                    “{t.quote}”
                  </blockquote>
                  
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center font-display text-lg text-[var(--ink)] shrink-0"
                      style={{ background: "linear-gradient(135deg, #e4c77a, #b87333)" }}>
                      {t.name.charAt(0)}
                    </div>
                    <div>
                      <div className="font-display text-lg text-[var(--cream)]">{t.name}</div>
                      <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--gold)] opacity-80">
                        {t.role}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* View more testimonials link or button if needed */}
        <div className="mt-12 flex justify-center md:justify-end">
          <motion.button
            whileHover={{ x: 5 }}
            className="flex items-center gap-3 font-impact text-[11px] tracking-[0.3em] text-[var(--cream-muted)] hover:text-[var(--gold)] transition-colors"
          >
            SEE ALL TESTIMONIALS <ChevronRight size={14} />
          </motion.button>
        </div>
      </div>
    </section>
  );
};

const Kicker = ({ index, label }) => (
  <div className="flex items-center gap-4">
    <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--gold)]">{index}</span>
    <span className="w-16 h-px bg-[var(--rule)]" />
    <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--cream-muted)]">{label.toUpperCase()}</span>
  </div>
);

export default Testimonials;
